module.exports = __webpack_public_path__ + "img/tableImg.fbaaea90.jpg";